<template>
  <div>
    <div  style=" height: 40px;"    >
    <van-nav-bar  
        left-arrow
        @click-left="onClickLeft"
        title="搜索配方"
        fixed
     
        safe-area-inset-top
      />
    </div>
    <div class="div-box">
      
      <div class="div-nav">
        <van-row style="border:solid 1px #fff;height: 35px;">
          <van-col style="border:solid 1px #fff;" span="19">
              <van-cell-group inset>
                <!-- 输入手机号，调起手机号键盘 -->
                <form @submit.prevent="formSubmit" action="javascript:return true">
                    <van-field
                      left-icon="search"
                      type="search"
                      v-model="searchVla"
                      @input="searchVlaInput"
                      @blur="searchVlaBlur"
                      @focus="searchVlaFocus"
                      ref="inputText" 
                      @keydown="handleKeyUp($event)"
                      class="search_in"
                      placeholder='搜索“丰田 凯美瑞 089 铂金珍珠白”'
                    />
                </form>
            </van-cell-group>
          </van-col>
          <van-col span="5">
           <div @click="screenClick" class="sea-inpt-div">
             <van-icon class="sea-inpt-siz" size="1rem" name="bars" />
             <span class="sea-inpt-siz">筛选</span>
           </div>
          </van-col>
        </van-row>
        <div v-show="!searchShowDiv" class="sort-style">
        
          <div style="margin-left:20px;">
            <span @click="triangleClick" class="iconDivT">{{firstText}}</span>
            <div class="iconDiv" style="width:12px;"></div>
            <van-icon v-show="triangle" class="iconX" @click="triangleClick" name="arrow-down" />
            <van-icon v-show="!triangle" class="iconS" @click="triangleClick" name="arrow-up" />
          </div>
          <div class="up-style">
            <div class="iconDiv"></div>
            <span v-show="queryPageData.data.sort=='desc'" style="margin-top: 7px;">由高到低</span>
            <span v-show="queryPageData.data.sort=='asc'"  style="margin-top: 7px;">由低到高</span>
            <img class="icon-img" style="margin-right:22px;" v-show="queryPageData.data.sort=='desc'" src="../assets/image/below.png" @click="sortImgClick" alt="">
            <img class="icon-img" style="margin-right:22px;" v-show="queryPageData.data.sort=='asc'" src="../assets/image/up.png" @click="sortImgClick" alt="">
            <div class="iconDiv" style="width:2px;"></div>
          </div>
        </div>
        <div v-show="!triangle" class="triangle-style">
          <div v-for="(item,index) in storArr" :key="index" @click="firstSortClick(item)" :style="queryPageData.data.firstSort === item.value ? 'color:rgb(225,86,87);':''" class="triangle-or">
            <span>{{item.text}}</span>
            <van-icon v-show="queryPageData.data.firstSort === item.value" name="success" color="rgb(225,86,87)" />
          </div>
        </div>
      </div>
      <div class="div-record" v-if="searchRecordList.length>0">
        <div v-for="(item,index) in searchRecordList" :key="index" @click="searchRecord(item)" style="width:80%;padding:0px 10%;text-align:left;line-height:30px;">
          {{item.searchKey}}
        </div>
        <div style="width:100%;text-align:center;color:#0082BB;height:30px;line-height:30px;">历史搜索记录</div>
      </div>
      <div v-show="searchShowDiv" class="div-subejc">
        <van-cell title="油漆品牌"   :border="false"/>
        <van-row>
            <van-col span='1'></van-col>
            <van-col span='22'>
                <div class="col-div">
                    <div v-for="(item,index) in paintArr" :key="index" @click="colCick(item)" :style="queryPageData.data.paintBrandCode === item.brandCode ? 'color:rgb(0,132,184);border: solid 1px rgb(204,230,241);background-color:rgb(204,230,241);':''" class="div-cell">
                        <span class="fontSize13">{{item.brandName}}</span>
                    </div>
                </div>
            </van-col>
            <van-col span='1'></van-col>
        </van-row>
      <van-cell 
        v-show="collapseShow" 
        title="汽车品牌" 
        is-link 
      >
        <template #right-icon>
          <div>
            <div style="display: block;float: right;" @click="carBrandShow = true"><van-icon style="margin-left:4px" name="arrow-down" color="#969799" size="16"/></div>
            <div v-if="recipeAddData.carBrandName" style="display: block;float: right;" @click="delClick('car_brand')"><van-icon class="collapse-icon"  color="red" size="20" name="cross" /></div>
            <div style="display: block;float: right;" class="van-cell__value" @click="carBrandShow = true">{{recipeAddData.carBrandName}}&nbsp;&nbsp;&nbsp;&nbsp; </div>
          </div>
        </template>
      </van-cell>
         <van-popup class="popup-style" v-model="carBrandShow" round position="bottom">
            <div class="cascader-input-style van-field__controls">
              <van-field
                left-icon="search"
                type="search"
                v-model="carBrandValue"
                class="stepper-div-btns"
                placeholder='查询汽车品牌'
              />
            </div>
          <van-cascader
              v-model="selectedBrandValue"
              title="请选择汽车品牌"
              active-color="#1989fa"
              :options="filterCarBrand"
              
              @close="carBrandShow = false"
              @finish="onCarBrandFinish"
              
          >
        </van-cascader>
        </van-popup>
        <van-cell 
          v-show="collapseShow" 
          title="车型" 
          is-link
        >
          <template #right-icon>
            <div>
              <div style="display: block;float: right;" @click="clickCarModel"><van-icon style="margin-left:4px" name="arrow-down" color="#969799" size="16"/></div>
              <div v-if="recipeAddData.carModelName" style="display: block;float: right;" @click="delClick('car_model')"><van-icon class="collapse-icon"  color="red" size="20" name="cross" /></div>
              <div style="display: block;float: right;" class="van-cell__value" @click="clickCarModel">{{recipeAddData.carModelName}}&nbsp;&nbsp;&nbsp;&nbsp; </div>
            </div>
          </template>
        </van-cell>
        <van-popup class="popup-style" v-model="carModelShow" round position="bottom">
          <div class="cascader-input-style van-field__controls">
              <van-field
                left-icon="search"
                type="search"
                v-model="carModelValue"
                class="stepper-div-btns"
                placeholder='查询车型'
              />
          </div>
          <van-cascader
              v-model="selectedModelValue"
              title="请选择车型"
              active-color="#1989fa"
              :options="filterCarModel"
              
              @close="carModelShow = false"
              @finish="onCarModelFinish"
              
          >
          </van-cascader>
        </van-popup>
        <van-cell 
          v-show="collapseShow" 
          title="车色号" 
          is-link 
        >
          <template #right-icon>
            <div>
              <div style="display: block;float: right;" @click="colorSizeClick"><van-icon style="margin-left:4px" name="arrow-down" color="#969799" size="16"/></div>
              <div v-if="fieldValue1" style="display: block;float: right;" @click="delClick('color_code')"><van-icon class="collapse-icon"  color="red" size="20" name="cross" /></div>
              <div style="display: block;float: right;" class="van-cell__value" @click="colorSizeClick">{{fieldValue1}}&nbsp;&nbsp;&nbsp;&nbsp; </div>
            </div>
          </template>
        </van-cell>
        <van-popup class="popup-style" v-model="show1" round position="bottom">
            <div class="cascader-input-style van-field__controls">
                <van-field
                  left-icon="search"
                  type="search"
                  v-model="iptValue"
                  class="stepper-div-btns"
                  placeholder='查询车色号'
                />
            </div>
            <van-cascader
                v-model="cascaderValue1"
                title="请选择车色号"
                active-color="#1989fa"
                :options="searchResult"
                @close="show1 = false"
                @finish="onFinish1"
                @change="optionsChange1"
            />
        </van-popup>
        <van-cell 
          title="年款" 
          is-link 
        >
          <template #right-icon>
            <div>
              <div style="display: block;float: right;" @click="yearClick"><van-icon style="margin-left:4px" name="arrow-down" color="#969799" size="16"/></div>
              <div v-if="recipeAddData.recipeYear"  style="display: block;float: right;" @click="delClick('model_year')"><van-icon class="collapse-icon"  color="red" size="20" name="cross" /></div>
              <div style="display: block;float: right;" class="van-cell__value" @click="yearClick">{{recipeAddData.recipeYear}}&nbsp;&nbsp;&nbsp;&nbsp; </div>
            </div>
          </template>
        </van-cell>
        <van-cell
          title="适用车龄"
          is-link
        >
          <template #right-icon>
            <div>
              <div style="display: block;float: right;" @click="vehicleClick"><van-icon style="margin-left:4px" name="arrow-down" color="#969799" size="16"/></div>
              <div v-if="recipeAddData.carAgeDesc" style="display: block;float: right;" @click="delClick('applicable_car_age')"><van-icon class="collapse-icon"  color="red" size="20" name="cross" /></div>
              <div style="display: block;float: right;" class="van-cell__value" @click="vehicleClick">{{recipeAddData.carAgeDesc}}&nbsp;&nbsp;&nbsp;&nbsp; </div>
            </div>
          </template>
        </van-cell>
        <van-popup
          v-model="pickerVehicleShow"
          position="bottom"
          round
          :style="{ height: '38%' }"
        >
          <van-picker
            title="选择车龄"
            show-toolbar
            default-index="1"
            :columns="vehicleColumns"
            @confirm="vehicleOnConfirm"
            @cancel="vehicleOnCancel"
            
          />
        </van-popup>
        <van-cell
          title="上传地域"
          v-show="collapseShow"
          is-link
          
          arrow-direction="down"
        >
          <template #right-icon>
            <div>
              <div style="display: block;float: right;" @click="territoryClick"><van-icon style="margin-left:4px" name="arrow-down" color="#969799" size="16"/></div>
              <div v-if="recipeAddData.uploadRegionName" style="display: block;float: right;" @click="delClick('upload_location')"><van-icon class="collapse-icon"  color="red" size="20" name="cross" /></div>
              <div style="display: block;float: right;" class="van-cell__value" @click="territoryClick">{{recipeAddData.uploadRegionName}}&nbsp;&nbsp;&nbsp;&nbsp; </div>
            </div>
          </template>
        </van-cell>
        <van-popup
          v-model="pickerTerritoryShow"
          position="bottom"
          round
          :style="{ height: '38%' }"
        >
          <van-picker
            title="选择省份"
            show-toolbar
            default-index="1"
            :columns="TerritoryColumns"
            @confirm="TerritoryOnConfirm"
            @cancel="TerritoryOnCancel"
          />
        </van-popup>
       <van-collapse v-model="activeName" accordion>
          <van-collapse-item title="配方分类" :value="queryPageData.data.recipeTypesValue" name="0">
              <template #value>
                <div>{{queryPageData.data.recipeTypesValue}}&nbsp;&nbsp;&nbsp;&nbsp; 
                  <van-icon v-if="queryPageData.data.recipeTypesValue" class="collapse-icon" @click="delClick('recipe_type')" color="red" size="20" name="cross" />
                </div>
              </template>
              <div class="div-subejc-box-recipe">
                  <!-- <div v-for="(item,index) in formulaTypeArr" :key="index" @click="pfClick(item)" :style="{'background-color':item.color,'color':item.fontColor}" class="div-subejc-div">
                      {{item.lab}}
                  </div> -->
                  <div v-for="(item,index) in formulaTypeArr" :key="index" @click="pfClick(item)" :style="queryPageData.data.recipeTypes[0] === item.val ? 'color:rgb(0,132,184);border: solid 1px rgb(204,230,241);background-color:rgb(204,230,241);':''" class="div-subejc-div">
                      {{item.lab}}
                  </div>
              </div>
          </van-collapse-item>
          <van-collapse-item v-show="collapseShow" :value="queryPageData.data.colorGroupValue" title="颜色组别" name="1">
                <template #value>
                  <div>{{queryPageData.data.colorGroupValue}}&nbsp;&nbsp;&nbsp;&nbsp; 
                    <van-icon v-if="queryPageData.data.colorGroupValue" class="collapse-icon" @click="delClick('color_group')" color="red" size="20" name="cross" />
                  </div>
                </template>
                <div class="div-subejc-box">
                    <div v-for="(item,index) in colorArrs" :key="index" @click="ysClick(item)" :style="queryPageData.data.colorGroup === item.itemKey ? 'color:rgb(0,132,184);border: solid 1px rgb(204,230,241);background-color:rgb(204,230,241);':''" class="div-subejc-div">
                        {{item.itemValue}}
                    </div>
                </div>
            </van-collapse-item>
            <van-collapse-item v-show="collapseShow" :value="queryPageData.data.colorSpecialValue" title="颜色效果" name="2">
                <template #value>
                  <div>{{queryPageData.data.colorSpecialValue}}&nbsp;&nbsp;&nbsp;&nbsp; 
                    <van-icon v-if="queryPageData.data.colorSpecialValue" class="collapse-icon" @click="delClick('color_effects')" color="red" size="20" name="cross" />
                  </div>
                </template>
                <div class="div-subejc-box">
                    <div v-for="(item,index) in colorSpecialArr" :key="index" @click="txClick(item)" :style="queryPageData.data.colorSpecial === item.itemKey ? 'color:rgb(0,132,184);border: solid 1px rgb(204,230,241);background-color:rgb(204,230,241);':''" class="div-subejc-div">
                        {{item.itemValue}}
                    </div>
                </div>
            </van-collapse-item>
        </van-collapse>
        <div class="BtnStyle" @click='prickerFewClick1' v-show="!collapseShow">
          <span>更多</span>
        </div>
        <div class="BtnStyle" @click='prickerMoreClick' v-show="collapseShow">
          <span>收起</span>
        </div>
        <div style="margin-top:50px;"></div>
      </div>
      
      <!-- 配方列表 -->
      <div v-show="!searchShowDiv" class="search-dev">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="recipeOrder.list.length==0?'没有匹配结果':'没有更多了'"
          @load="onLoad"
        >
        <!-- 单子 -->
        <div class="order-box" @click="orderClick(item)"  v-for="(item,index) in recipeOrder.list" :key="index">
          <div class="div-box-txt">
            <div class="d1">
              <!-- colorSpecial 值为10071004:素色时不渐变，其他渐变 -->
              <div class="d1-title1" :style="item.colorSpecial!=10071004?'background-color:'+item.colorRgb+';background-image: linear-gradient('+item.gcColorRgb+','+item.colorRgb+','+item.colorRgb+','+item.gcColorRgb+')':'background-color:'+item.colorRgb"></div>

              <div class="d1-title2">
                <div class="d1-title1-txt1">
                  <van-row justify="end">
                    <van-col class="env-col"></van-col>
                    <van-col style="display: flex;" span="15">
                      <div class="txt-span">{{item.colorCode}} {{item.colorName}}</div>
                      <van-icon v-if="item.collectionTime == null" size="1.2rem" color="rgb(204,204,204)" name="star" />
                      <van-icon v-else size="1.2rem" color="rgb(254,200,9)" name="star" />
                    </van-col>
                    <van-col style="blackgroun:red;" span="8">
                      <!-- 判断油漆品牌诺彬，闪彩 -->
                      <img class="img-log" v-if="item.paintBrandCode ==='NBW' || item.paintBrandCode ==='NBS1K' || item.paintBrandCode ==='NBS2K'" src="../assets/image/brand2.png" alt="">
                      <img class="img-log" v-else src="../assets/image/brand1.png" alt="">
                    </van-col>
                  </van-row>
                  <van-row>
                    <van-col span="24">
                      <div style="margin-left: 10px" v-if="item.avgScore>0">
                        <img
                          v-for="(item, index) in commentLevelImg[index]"
                          :src="item.url"
                          :key="index"
                          class="img-styles"
                          alt=""
                        />
                        <span style="margin: 1px 0 0 8px;font-size:13px">{{item.avgScore}}分</span>
                      </div>
                      <div style="margin-left: 10px" v-else>
                        <span style="margin: 1px 0 0;font-size:13px">暂无评分</span>
                      </div>
                    </van-col>
                  </van-row>
                  <div class="div-end">
                    <div class="end-d1">
                      <div class="icon-circle">
                          <span class="icon-circle-class">{{item.recipeLabel}}</span>
                      </div>
                      <div class="icon-circleTwo">
                        <span class="icon-circle-class">{{item.paintBrandLabel}}</span>
                      </div>
                      <div class="icon-circleThree" v-if="item.collectionCount>0">
                        <span class="icon-circle-class">{{item.collectionCount}}次收藏</span>
                      </div>
                    </div>
                    <div class="end-preview">
                      <div v-if="item.photo === null || item.photo === ''" class="icon-imgs-style">
                        <span  style="font-size:13px;color:rgb(0,145,220)">暂无图片</span>
                      </div>
                      <div @click.stop="imgClick(item)" v-else class="icon-imgs-style">
                        <van-icon name="photo-o" />
                        <span color='rgb(0,145,220)' style="font-size:13px;color:rgb(0,145,220);padding: 0px 3px;">
                          预览
                        </span>
                        <div id="triangle-right"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d2">
              <van-row class="van-rows">
                <van-col class="env-col" span="2"></van-col>
                <van-col span="20">
                  <div class="span-h3-box">
                    <img style="height:1.3rem;position: relative;top:3px;" src="../assets/image/vehicleIcon.png" alt="">
                    <span class="span-h3">{{item.carBrandName}} - {{item.carModelName}}</span>
                  </div>
                </van-col>
              </van-row>
              <van-row class="van-rows">
                <van-col class="env-col" span="2"></van-col>
                <van-col span="12">
                
                  <span class="span-min">上传时间&#12288;<span style="font-size:0.7rem;margin-top:.1rem;color:black;" >{{item.uploadTimeStr}}</span></span>
                </van-col>
                <van-col span="8">
                  <div>
                    <span class="span-min">上传地域&#12288;<span v-if="item.uploadRegionName ===''" style="font-size:0.7rem;margin-top:.1rem;color:black;" >通用</span>
                    <span v-else style="font-size:0.7rem;margin-top:.1rem;color:black;" >{{item.uploadRegionName}}</span></span>
                  </div>
                 
                </van-col>
              </van-row>
              <van-row></van-row>
              <van-row class="van-rows">
                <van-col class="env-col" span="2"></van-col>
                <van-col span="12">
                  <span class="span-min">适用车龄&#12288;<span style="font-size:0.7rem;margin-top:.1rem;color:black;" >{{item.carAgeDesc}}</span></span>
                  <!-- <div v-else>
                    <span class="span-min">上传地域&#12288;<span v-if="item.uploadRegionName ===''" style="font-size:0.7rem;margin-top:.1rem;color:black;" >通用</span>
                    <span v-else style="font-size:0.7rem;margin-top:.1rem;color:black;" >{{item.uploadRegionName}}</span></span>
                  </div> -->
                </van-col>
                <van-col span="8">
                  <span class="span-min">车型年款&#12288;<span class="span-colorOne">{{item.recipeYear}}</span></span>
                  <!-- <span v-else style="margin-left:24px" class="span-min">年款&#12288;<span class="span-colorOne">{{item.recipeYear}}</span></span> -->
                </van-col>
              </van-row>
              <van-row class="van-rows"> 
                <van-col class="env-col" span="2"></van-col>
                <van-col span="12">
                  <span style="" class="span-min">调漆工序&#12288;<span class="span-colorOne">{{item.isThree==1 ?'多工序':'单工序'  }}</span></span>
                </van-col>
                <van-col span="8">
                  <span class="span-min">偏差描述&#12288;<span style="font-size:0.7rem;margin-top:.1rem;color:black;" >{{item.deviantColor}}</span></span>
                  
                  <!-- <span v-else style="margin-left:24px" class="span-min">年款&#12288;<span class="span-colorOne">{{item.recipeYear}}</span></span> -->
                </van-col>
              </van-row>
            </div>
          </div>
        </div>
        </van-list>
        
      </div>
    </div>
    <van-popup v-model="pickerShow" position="bottom" round :style="{ height: '38%' }" >
        <van-picker
        title="选择位置"
        show-toolbar
        default-index="1"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
        />
    </van-popup>
    <van-popup
      v-model="pickerShow1"
      position="bottom"
      round
      :style="{ height: '38%' }"
    >
      <van-picker
        title="选择年款"
        show-toolbar
        default-index="1"
        :columns="columnsN"
        @confirm="onConfirm"
        @cancel="onCancelss"
      />
    </van-popup>
    <div class="searchBtn">
      <div class="searchBtn-d2">
        <van-button @click="resetSearch" round type="info">重置</van-button>
      </div>
      <div class="searchBtn-d1">
        <van-button class="top" @click="searchDivClick" round type="info">搜索</van-button>
      </div>
    </div>
    <!-- 图片预览 -->
    <van-image-preview v-model="showImg" :images="images" @change="onChange">
    </van-image-preview>
  </div>
</template>
<script>
import Api from "../api/api";
import { Toast } from 'vant';
import {colorRgb } from "../common/util.js";
// import common from "../../common/common";
// import { NavBar  } from "vant";
import {mapState} from 'pinia'
 import storeState from '../store/index'  //storeId就是导出的那个值

export default {
  // 注册组件
  // components: { searchCondition },
  data() {
    return {
      offsetTop:'margin-top:0px;',
      showImg: false,// 图片预览
      index: 0,
      images: [],// 图片预览列表

      loading: false, // 是否触发分页请求
      finished: false, // 是否所有数据加载完成
        triangle: true, // 显示隐藏
        firstText: "综合排序", // 排序名字
        searchVla: '', // 搜索条件
        activeName: "", // collapse组件值
        show:false,   // 元素显示隐藏
        show1: false,// 请选择车色号显示隐藏
        // 车龄
        pickerVehicleShow:false,
        // 上传地域
        pickerTerritoryShow: false,

        carBrandShow: false, // 弹框是否关闭
        carModelShow: false, // 弹框是否关闭

        iptValue:'', // 查询车色号输入框
        carBrandValue: "", // 查询汽车品牌
        carModelValue: "", // 查询车型
        // 汽车品牌选项列表，children 代表子选项，支持多级嵌套
        carBrandOptions: [

        ],
        // 车型选项列表，children 代表子选项，支持多级嵌套
        carModelOptions: [

        ],
        selectedBrandValue: "", // 选择汽车品牌值
        selectedModelValue: "", // 选择车型值
        
        // 车品牌，车型
        fieldValue1: '',
        cascaderValue1: '', // 选择车色号值
        options1:[], // 色母搜索
        
        // 油漆品牌数组
        paintArr:[],
        pickerShow: false, // 选择年款显示隐藏
        pickerShow1: false, // 选择年款显示隐藏
        columns: [], // 日期
        collapseShow: false, // 更多,收起切换
        // 油漆品牌
        dataPar:{
          oemCode:'',
          vehicle:'',
          colorNum: '',
          paintColor: '', // 油漆品牌code
          paintColorName: "", // 油漆品牌名称
          carModelCode: '', // 车型代码
          carBrandCode: '', // 品牌代码
          brandUrl: '', // 油漆品牌url
          gdColorId: '', // 颜色ID
          gdModelId: '',  // 车型ID
          colorRgb: '', // 色号RGB
        },
        // 年款
        recipeAddData: { 
        // 年款
        recipeYear:"",
        // 地域
        uploadRegionCode: '',
        uploadRegionName: '',
        imgList: [],// 上传照片
        // 适用车龄 100001
        carAge: '',
        // 适用车龄
        carAgeDesc: '',
        // 色差描述/使用建议
        commentInfo: '',
        // 备注配方
        recipeRemark: '',
        // 汽车品牌代码
        carBrandCode: '',
        // 汽车品牌名称
        carBrandName: '',
        // 车型代码
        carModelCode: '',
        // 车型名称
        carModelName: '',
        // 车型ID
        gdModelId: '',
        // 油漆品牌名称
        paintBrandName: '',
        // 油漆品牌代码
        paintBrandCode: '',
        // 油漆品牌图片
        paintBrandUrl: '',
        // 颜色ID
        gdColorId: '',
        // 是否是三工序
        isThree: null,
        // 工序的数据
        procedures: [],
        // 色号名字
        colorName: '',
        // 色号RGB
        colorRgb: '',
      },
      // 评分
      commentLevelImg: [],
      // 日期
      columnsN: [
        "2025",
        "2024",
        "2023",
        "2022",
        "2021",
        "2020",
        "2019",
        "2018",
        "2017",
        "2016",
        "2015",
        "2014",
        "2013",
        "2012",
        "2011",
        "2010",
        "2009",
        "2008",
        "2007",
        "2006",
        "2005",
        "2004",
        "2003",
        "2002",
        "2001",
        "2000",
        "1999",
        "1998",
        "1997",
        "1996",
        "1995",
        "1994",
        "1993",
        "1992",
        "1991",
        "1990",
      ],
      // 查询配方图片列表参数
      datas:{
        brandCode:''
      },
      // 车龄
      vehicleColumns: [],
      vehicleColumnsData: [], // 车龄列表
      // 上传地域
      TerritoryColumns: [],
      TerritoryColumnsData: [], // 地域列表
      // 配方分类
      formulaTypeArr: [
        {
          lab:'官方',
          val: 1,
          color: 'rgb(235,235,235)',
          fontColor: '#969799'
        },
        {
          lab:'现场配方',
          val: 5,
          color: 'rgb(235,235,235)',
          fontColor: '#969799'
        },
        {
          lab:'我的配方',
          val: 2,
          color: 'rgb(235,235,235)',
          fontColor: '#969799'
        },
        {
          lab:'我的收藏',
          val: 3,
          color: 'rgb(235,235,235)',
          fontColor: '#969799'
        },
        {
          lab:'用户上传',
          val: 4,
          color: 'rgb(235,235,235)',
          fontColor: '#969799'
        },
      ],
      storArr:[
        {text:'综合排序',value:'4'},
        // {text:'使用次数',value:'1'},
        {text:'配方评分',value:'2'},
        {text:'上传时间',value:'3'},
      ],
      formulaTypeArrData: [],
      // 颜色组别
      colorArrs: [],
      // 颜色效果
      colorSpecialArr: [],
      // 查询配方列表
      queryPageData: { 
        // 当前页码
        page: 0,
        // 每页条数
        rows: 10,
        data:{
          // 车龄
          carAge:'',
          // 车辆品牌
          carBrandCode:'',
          // 车辆OEM
          carOemCode	:'',
          // 颜色组别
          colorGroup: null,
          // 颜色效果
          colorSpecial: null,
          // GD色号ID
          gdColorId:'',
          // 颜色名字
          colorName:'',
          // GD车型ID
          gdModelId:'',
          // 搜索关键字
          keys: [],
          // 油漆品牌代码
          paintBrandCode:'',
          // 
          recipeTypes: [],
          // 年款
          recipeYear: null,
          // 排序方式
          sort:'desc',
          // 上传地域代码
          uploadRegionCode:'',
          // 优先排序字段
          firstSort: '4',
        }
      },
      //关键字历史记录
      searchRecordList:[],
      // 分页参数
      recipeOrder: {
        currPage: 0,
        pageSize: 10,
        totalCount: '',
        totalPage: '',
        list:[],
      },
      
    };
  },
  computed: {
    ...mapState(storeState,['searchShowDiv']),
    // 颜色搜索
    searchResult() {
      let price = this.options1.filter((item) => {
          return item.text.toLowerCase().includes(this.iptValue.toLowerCase());
      });
      if (price.length === 0) {
        this.iptValue = '其他';
        return this.options1.filter((item) => {
            return item.text.toLowerCase().includes(this.iptValue.toLowerCase());
        });
      }
      return price;
    },
    // 品牌搜索
    filterCarBrand() {
      let price = this.carBrandOptions.filter((item) => {
          return item.text.toLowerCase().includes(this.carBrandValue.toLowerCase());
      });
      if (price.length === 0) {
        // this.carBrandValue = '其他';
        return this.carBrandOptions.filter((item) => {
          return item.text.toLowerCase().includes(this.carBrandValue.toLowerCase());
        });
      }
      return price;
    },
    // 车型
    filterCarModel() {
      let price = this.carModelOptions.filter((item) => {
          return item.text.toLowerCase().includes(this.carModelValue.toLowerCase());
      });
      if (price.length === 0) {
        // this.carModelValue = '其他';
        return this.carModelOptions.filter((item) => {
          return item.text.toLowerCase().includes(this.carModelValue.toLowerCase());
        });
      }
      return price;
    }
  },
  methods: {
    colorRgb,
    clearJsonData() {
      Object.keys(this.queryPageData.data).forEach((key) => {
        if(typeof this.queryPageData.data[key] === 'string' || typeof this.queryPageData.data[key] === 'number') {
          this.queryPageData.data[key] = '';
        } else if (this.queryPageData.data[key] instanceof Array) {
          this.queryPageData.data[key] = [];
        }
      });
      Object.keys(this.recipeAddData).forEach((key) => {
        if(typeof this.recipeAddData[key] === 'string' || typeof this.queryPageData.data[key] === 'number') {
          this.recipeAddData[key] = '';
        } else if (this.recipeAddData[key] instanceof Array) {
          this.recipeAddData[key] = [];
        }
      });
      this.fieldValue1 = "";
      this.recipeAddData.recipeYear = "";
      this.queryPageData.data.firstSort = '4';
      this.queryPageData.data.paintBrandCode = "";
      this.queryPageData.data.sort = "desc";
    },
    // 图片预览
    imgClick(item) {
      this.images = []
      this.showImg = true;
      let datas = {
        recipeNo: item.recipeNo
      }
      Api.recipeImg(datas).then((res) => {
        this.images.push(res.data.result.photo)
      })
    },
    //查询历史搜索记录
    queryOperationLog() {
      let parmas={
        searchKey:this.searchVla
      };

      // 查询历史搜索记录
      Api.queryOperationLog(parmas).then((res) => {
        console.log("queryOperationLog",res.data.result.length)
        if (res.data.result.length != 0) {
          this.searchRecordList=res.data.result;
        }else{
          this.searchRecordList=[];
        }
      });
    },
    //选择查询历史
    searchRecord(item){
      console.log("item:",item);
      let that = this;
      that.searchVla=item.searchKey;
      that.searchVlaInput();
      setTimeout(() => {
        that.searchDivClick();
      },100);
    },
    // 导航头返回
    onClickLeft() {
      const storeStates = storeState();
      storeStates.searchVla = "";
      // 清空油漆品牌
      sessionStorage.setItem("paintColor",'');
      sessionStorage.setItem("paintColorName",'');
      this.dataPar.paintColorName = '';
      this.dataPar.paintColor = '';
      
      this.triangle = true;
      this.resetSearch();
      this.$parent.fatherMethod();
    },
    onChange(index) {
      this.index = index;
    },
    // 油漆品牌
    colCick(val) { 
        this.dataPar.paintColorName = val.brandName;
        this.dataPar.paintColor = val.brandCode;
        this.dataPar.brandUrl = val.brandUrl;
        // 油漆品牌代码
        this.queryPageData.data.paintBrandCode = val.brandCode;
        sessionStorage.setItem("paintColor",val.brandCode);
        sessionStorage.setItem("paintColorName",val.brandName);
        console.log("数据",this.dataPar);
    },
    // 年款
    yearClick() {
      this.pickerShow1 = true;
    },
    // 选择年款的 索引
    onConfirm(value, index) {
      //   this.recipeAddData.
      this.recipeAddData.recipeYear = value*1;

      this.queryPageData.data.recipeYear = value*1;
      this.pickerShow1 = false;
    },
    // 选择年款,取消
    onCancelss() {
      this.pickerShow1 = false;
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onCarBrandFinish({selectedOptions}) {
      this.carBrandShow = false;
      this.selectedBrandValue = selectedOptions[0].value;
      this.recipeAddData.oemCode=selectedOptions[0].oemCode;
      this.recipeAddData.carBrandCode=selectedOptions[0].value;
      this.recipeAddData.carBrandName=selectedOptions[0].text;
      this.recipeAddData.carModelName="";
      this.recipeAddData.carModelCode="";
      this.recipeAddData.gdModelId="";

      this.fieldValue1 = '';
      this.cascaderValue1 = '';


      this.queryPageData.data.carOemCode = selectedOptions[0].oemCode;
      this.queryPageData.data.carBrandCode = selectedOptions[0].value;
      this.queryPageData.data.gdModelId = "";
      this.queryPageData.data.gdColorId = "";
      this.queryPageData.data.colorName = "";

      // 响应结果改造
      let arrQ = []
      
      // 请求参数
      // let parmas = {
      //   brandCode:""
      // }
      // parmas.brandCode = selectedOptions[0].value;
      let parmas = {
        brandName:""
      }
      parmas.brandName = selectedOptions[0].text
      // 根据品牌,获取车型列表
      Api.vehicleModelList(parmas).then((res) => {
        // 如果车型为空
        if (res.data.result.length != 0) {
          // 改造函数结构
          for (let index = 0; index < res.data.result.length; index++) {
            let obj = {text:'',value: '',modelCode:'',gdModelId: '',brandCode:'',brandName:'',oemCode:'' }
            obj.text = res.data.result[index].modelName;
            obj.value = res.data.result[index].gdModelId;
            obj.modelCode = res.data.result[index].modelCode;
            obj.modelName = res.data.result[index].modelName;
            obj.gdModelId = res.data.result[index].gdModelId;
            // 改造后接口
            obj.brandCode = res.data.result[index].brandCode;
            obj.brandName = res.data.result[index].brandName;
            obj.oemCode = res.data.result[index].oemCode;
            arrQ.push(obj)
          
          }
        }
        this.carModelValue = '';
        this.carModelOptions = arrQ;
      })

      // var pps = {oemCode:selectedOptions[0].oemCode};
      // 色号接口
      // Api.colorNum(pps).then((res) => {
      //   this.options1 = [];
      //   if (res.data.result.length === 0) {
      //     this.fieldValue1 = '';
      //     this.options1 = []
      //   }
      //   // 改造数据结构
      //   for (let index = 0; index < res.data.result.length; index++) {
      //     let obj = {text:'',value: '',gdColorId: '',colorRgb: '',colorCode: '',colorName: ''}
      //     obj.text = res.data.result[index].colorCode + ' ' + res.data.result[index].colorName;
      //     // obj.value = res.data.result[index].colorCode;
      //     // colorCode重复。绑定gdColorId
      //     obj.value = res.data.result[index].gdColorId;
      //     obj.colorName = res.data.result[index].colorName;
      //     obj.gdColorId = res.data.result[index].gdColorId;
      //     obj.colorRgb = res.data.result[index].colorRgb;
      //     obj.colorCode = res.data.result[index].colorCode;
      //     this.options1.push(obj)
      //   }
      // })
      this.iptValue = '';
  
    },

    // 全部选项选择完毕后，会触发 finish 事件
    onCarModelFinish({selectedOptions}) {
      this.carModelShow = false;
      // this.dataPar.vehicle = this.fieldValue;
      this.selectedModelValue = selectedOptions[0].value;
      this.recipeAddData.gdModelId=selectedOptions[0].gdModelId;
      this.recipeAddData.carModelCode=selectedOptions[0].modelCode;
      this.recipeAddData.carModelName=selectedOptions[0].modelName;
      
      this.fieldValue1 = '';
      this.cascaderValue1 = '';
      this.dataPar.gdColorId = "";
      this.dataPar.colorRgb = "";
      this.dataPar.colorCode = "";
      this.dataPar.colorName = "";
      this.dataPar.colorNum = "";
      this.queryPageData.data.gdColorId = "";
      this.queryPageData.data.colorName = "";

      // 信息重新赋值
      this.dataPar.carBrandCode = selectedOptions[0].brandCode;
      this.dataPar.carBrandName = selectedOptions[0].brandName;
      this.dataPar.oemCode = selectedOptions[0].oemCode;
      let pps = {oemCode:this.dataPar.oemCode}
      // 色号接口
      Api.colorNum(pps).then((res) => {
        this.options1 = [];
        if (res.data.result.length === 0) {
          this.fieldValue1 = '';
          // 去掉其他
          this.options1 = [{text:'其他',value: ''}]
        }
        console.log('色号',res);
        // 改造数据结构
        for (let index = 0; index < res.data.result.length; index++) {
          let obj = {text:'',value: '',gdColorId: '',colorRgb: '',colorCode: '',colorName: ''}
          // 没有colorCode的话，不显示
          if (res.data.result[index].colorCode == null) {
            obj.text = res.data.result[index].colorName;
          } else {
            obj.text = res.data.result[index].colorCode + '\u3000\u3000' + res.data.result[index].colorName;
          }
          obj.value = res.data.result[index].gdColorId;
          obj.colorName = res.data.result[index].colorName;
          obj.gdColorId = res.data.result[index].gdColorId;
          obj.colorRgb = res.data.result[index].colorRgb;
          obj.colorCode = res.data.result[index].colorCode;
          this.options1.push(obj)
          // 去掉其他
          if (res.data.result.length === index+1) {
            let obj = {text:'其他',value: ''}
            this.options1.push(obj)
          }
        }
       this.iptValue = '';
      })

      this.queryPageData.data.gdModelId = selectedOptions[0].gdModelId;
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.text).join('/');
      this.dataPar.vehicle = this.fieldValue;
      let pp = this.fieldValue.split('/')[0];
      
      
      // 通过pps查找当前车辆品牌的对象，获取oem
      for (let index = 0; index < this.options.length; index++) {
        if (pp == this.options[index].text)  {
          // 车龄oem
          var pps = {oemCode:this.options[index].oemCode}
          this.dataPar.oemCode = this.options[index].oemCode;
          
          this.queryPageData.data.carOemCode = this.options[index].oemCode;
        }
      }
      // 找出选择的品牌
      let ppName = this.fieldValue.split('/')[0];
      let cxName = this.fieldValue.split('/')[1];
      // 找出当前品牌的数据
      if (this.options.length != 0) {
        for (let index = 0; index < this.options.length; index++) {
          if (this.options[index].text === ppName) {
            // 汽车品牌code
            this.dataPar.carBrandCode = this.options[index].value;
            this.queryPageData.data.carBrandCode = this.options[index].value;
            this.opts = this.options[index].children;
          }
        }
        if (this.opts.length != 0) {
          for (let index = 0; index < this.opts.length; index++) {
            if (this.opts[index].text == cxName) {
              // 车型code
              this.dataPar.carModelCode = this.opts[index].value;
              this.dataPar.gdModelId = this.opts[index].gdModelId;
              // 车型ID
              this.queryPageData.data.gdModelId = this.opts[index].gdModelId;
            }
          }
        }
      }
    },
    onFinish1({ selectedOptions }) {
      console.log("选择",selectedOptions);
      this.show1 = false;
      this.fieldValue1 = selectedOptions.map((option) => option.text).join('/');
      console.log("AA",selectedOptions.map((option) => option.text).join('/'));

      this.cascaderValue1 = selectedOptions[0].value;
      this.recipeAddData.gdColorId = selectedOptions[0].gdColorId;
      this.recipeAddData.colorRgb = selectedOptions[0].colorRgb;
      // 色号ID
      this.queryPageData.data.gdColorId = selectedOptions[0].gdColorId;
      this.queryPageData.data.colorName = selectedOptions[0].colorName;
    },
    optionsChange1() {
      // 查找当前色号的gdColorId
      if (this.cascaderValue1 === 'rest') {
        this.colorPopup = true;
      }
    },
    clickCarModel() {
      if (this.recipeAddData.carBrandName) {
        this.carModelShow = true;
      } else {
        Toast('请先选择汽车品牌');
      }
    },
    // 色号
    colorSizeClick () {
      if (this.recipeAddData.carModelName) {
        this.show1 = true;
      } else {
        Toast('请先选择车型');
      }
    },
    
    async ApiMountend() {
        const storeStates=storeState();
        // 油漆品牌
        await Api.paintBrand({}).then((res) => {
            this.paintArr = res.data.result;
            // this.dataPar.paintColorName = res.data.result[0].brandName;
            // this.dataPar.paintColor = res.data.result[0].brandCode;
            // this.dataPar.brandUrl = res.data.result[0].brandUrl;

            this.dataPar.paintColorName = sessionStorage.getItem("paintColorName");
            this.dataPar.paintColor = sessionStorage.getItem("paintColor");

            
            // 搜索
            if (!storeStates.searchShowDiv) {
              this.queryPageData.data = storeStates.queryPageData
              this.searchDivClick();
            } else {
              // this.queryPageData.data.paintBrandCode = res.data.result[0].brandCode;
              this.queryPageData.data.paintBrandCode = sessionStorage.getItem("paintColor");
            }
        })
        // 车辆品牌
        Api.vehicleList({}).then((res) => {
          let brandArr = [];
            // 遍历所有品牌，改变成可用的数据
            for (let index = 0; index < res.data.result.length; index++) {
              let obj = {text:'',value: '',oemCode: ''}
              obj.text = res.data.result[index].brandName;
              obj.value = res.data.result[index].brandCode;
              obj.oemCode = res.data.result[index].oemCode;
              brandArr.push(obj)
            }
            this.carBrandValue = '';
            this.carBrandOptions = brandArr;
        })
        // 车龄
        Api.keyValue(1004).then((res) => {
          for (let index = 0; index < res.data.result.length; index++) {
            // if (res.data.result[index].itemType === 1004) {
              this.vehicleColumns.push(res.data.result[index].itemValue);
              this.vehicleColumnsData.push(res.data.result[index]);
            // }
          }
        });
        // 上传地域
        let provinceData = {
          countryCode: storeStates.countryCode
        }
        Api.province(provinceData).then((res) => {
          console.log("上传地域",res);
          for (let index = 0; index < res.data.result.length; index++) {
            this.TerritoryColumns.push(res.data.result[index].provinceName);
            this.TerritoryColumnsData.push(res.data.result[index]);
          }
          console.log('this.TerritoryColumns', this.TerritoryColumns)
        });
        // 颜色组别
        Api.keyValue(1006).then((res) => {
          this.colorArrs = res.data.result;
        });
        // 颜色特性
        Api.keyValue(1007).then((res) => {
          this.colorSpecialArr = res.data.result.filter(
            (item) => item.itemKey !== 10071001
          );
        });
    },
    // 车龄
    vehicleClick() {
      this.pickerVehicleShow = true;
    },
    vehicleOnConfirm(value, index) {
      this.recipeAddData.carAgeDesc = value;
      this.recipeAddData.carAge = this.vehicleColumnsData[index].itemKey;

      this.vehicleValue = value;
      this.pickerVehicleShow = false;

      // 车龄ID
      this.queryPageData.data.carAge = this.vehicleColumnsData[index].itemKey;
    },
    vehicleOnCancel(picker, value, index) {
      this.pickerVehicleShow = false;
    },
    // 上传地域
    territoryClick() {
      this.pickerTerritoryShow = true;
    },
    TerritoryOnConfirm(value, index) {
      
      this.recipeAddData.uploadRegionName = value;
      this.recipeAddData.uploadRegionCode = this.TerritoryColumnsData[index].provinceCode;
      this.pickerTerritoryShow = false;
      
      // 上传地域代码
      this.queryPageData.data.uploadRegionCode = this.TerritoryColumnsData[index].provinceCode;
    },
    TerritoryOnCancel(picker, value, index) {
      this.pickerTerritoryShow = false;
    },
    // 年款的点击事件
    prickerClick() {
        this.pickerShow = true;
        this.activeName = "3";
    },
    // 配方分类
    pfClick(val) {
      if (this.queryPageData.data.recipeTypes === val.val) {
        this.queryPageData.data.recipeTypes = [];
        this.queryPageData.data.recipeTypesValue = '';
      } else {
        this.queryPageData.data.recipeTypes = []
        this.queryPageData.data.recipeTypes.push(val.val);
        this.queryPageData.data.recipeTypesValue = val.lab;
        console.log(this.queryPageData.data);
      }
    },
    // pfClick(value) {
    //     // 有就添加，没有就删除
    //     if (this.queryPageData.data.recipeTypes.indexOf(value.val) > -1) {
    //       // 删除颜色
    //       for (let index = 0; index < this.queryPageData.data.recipeTypes.length; index++) {
    //         this.formulaTypeArr[value.val - 1].color = 'rgb(235,235,235)';
    //         this.formulaTypeArr[value.val - 1].fontColor = '#969799';
    //         // 
    //       }
    //       // 删除值
    //       this.queryPageData.data.recipeTypes.splice(this.queryPageData.data.recipeTypes.indexOf(value.val), 1)
    //     } else {
    //       // 添加值
    //       this.queryPageData.data.recipeTypes.push(value.val);
    //       // 添加颜色
    //       for (let index = 0; index < this.queryPageData.data.recipeTypes.length; index++) {
    //         this.formulaTypeArr[value.val - 1].color = 'rgb(204,230,241)';
    //         this.formulaTypeArr[value.val - 1].fontColor = 'rgb(0, 132, 184)';
    //       }
    //     }
    // },
    // 颜色组别
    ysClick(val) {
      if (this.queryPageData.data.colorGroup === val.itemKey) {
        this.queryPageData.data.colorGroup = '';
        this.queryPageData.data.colorGroupValue = ''; 
      } else {
        this.queryPageData.data.colorGroup = val.itemKey;
        this.queryPageData.data.colorGroupValue = val.itemValue;
      }
    },
    txClick(val) {
      if (this.queryPageData.data.colorSpecial === val.itemKey) {
        this.queryPageData.data.colorSpecial = '';
        this.queryPageData.data.colorSpecialValue = '';
      } else {
        this.queryPageData.data.colorSpecial = val.itemKey;
        this.queryPageData.data.colorSpecialValue = val.itemValue;
      }
    },
    // 正序反序
    sortImgClick () {
      if (this.queryPageData.data.sort=='desc') {
        this.queryPageData.data.sort = 'asc';
        this.searchDivClick();
      } else {
        this.queryPageData.data.sort = 'desc';
        this.searchDivClick();
      }
    },
    triangleClick() {
      
      if (this.triangle) {
        this.triangle = false;
      } else {
        this.triangle = true;
      }
    },
    // 展开
    prickerMoreClick() {
      this.collapseShow = false;
    },
    prickerFewClick1() {
      this.collapseShow = true;
    },
    // 选择年款,取消
    onCancel() { 
        this.pickerShow = false;
    },
    // 搜索输入框
    searchVlaInput() {
      this.searchVla = this.searchVla.replaceAll(" ","，");
      this.searchVla = this.searchVla.replaceAll(",","，");
      this.searchVla = this.searchVla.replaceAll("/","，");
      this.searchVla = this.searchVla.replaceAll("、","，");
      this.queryPageData.data.keys = this.searchVla.split('，')
    },
    //聚焦搜索框
    searchVlaFocus(){
      this.queryOperationLog();
    },
    searchVlaBlur() {
      let that=this;
      let keysIndex = this.queryPageData.data.keys.length;
      for (let index = 0; index < keysIndex; index++) {
        if (this.queryPageData.data.keys[index] == '' ) {
          // this.searchVla.splice(index,1);
          this.queryPageData.data.keys.splice(index,1);
        }
      }

      setTimeout(() => {
        that.searchRecordList = [];
      }, 200);
    },
    topss () {
        let html =document.documentElement 
        var timer = setInterval(() => {
            if (html.scrollTop<=0) {
                clearInterval(timer)
            }
            html.scrollTop=html.scrollTop-20
        }, 0);
    },
    // 搜索
    searchDivClick() {
      // 滚动事件
      // debugger
      if(!this.dataPar.paintColor){
        Toast("请选择油漆品牌");
        this.loading = false;
        return;
      }
      const storeStates = storeState()
      storeStates.searchShowDiv = false;

      let html =document.documentElement 
      var timer = setInterval(() => {
          if (html.scrollTop<=0) {
              clearInterval(timer)
          }
          html.scrollTop=html.scrollTop-20
      }, 1);

      this.triangle = true;
      this.recipeOrder.currPage = '';
        this.recipeOrder.pageSize = 10;
        this.recipeOrder.totalCount = '';
        this.recipeOrder.totalPage = '';
        this.recipeOrder.list = [];

        // 搜索条件
        this.queryPageData.page = 0;

        this.finished = false;
        this.loading = true;

        this.queryPageData.page += 1;
        console.log('jsondata',this.queryPageData)
        // 进入首页，请求数据
        Api.queryPage(this.queryPageData).then((res) => {
          this.commentLevelImg = [];
          this.recipeOrder.list = [];
          // this.loading = false;
          if (res.data.success) {
           this.loading = false;
           if (res.data.result.totalPage === 0) {
                this.finished = true;
            }
            this.recipeOrder.currPage = res.data.result.currPage;
            this.recipeOrder.pageSize = res.data.result.pageSize;
            this.recipeOrder.totalCount = res.data.result.totalCount;
            this.recipeOrder.totalPage = res.data.result.totalPage;
            
            // 配方平均几颗星
          for (let index = 0; index < res.data.result.list.length; index++) {
            this.recipeOrder.list.push(res.data.result.list[index]);
            // 评分
            let imgUrlArrs = [];
            let avgScores = res.data.result.list[index].avgScore
            let decimalPart = avgScores - Math.floor(avgScores);
            let lenghtOr =0;
            let halfFlag = false;
            if (0<decimalPart    && decimalPart < 0.5) {
                   lenghtOr=Math.floor(avgScores);
            } else if (decimalPart >= 0.5 && decimalPart < 0.9) {
                   lenghtOr=Math.floor(avgScores)+1;
                   halfFlag = true;
            } else {
                   lenghtOr=Math.floor(avgScores);
            }
     
            for (let index = 0; index < lenghtOr; index++) {
                  if(index+1== lenghtOr && halfFlag){
                    imgUrlArrs.push({ url: require("../assets/image/scoreHalf.png") })
                  }else{
                    imgUrlArrs.push( { url: require("../assets/image/scoreTrue.png") })
                  }
                
            }
            this.commentLevelImg.push(imgUrlArrs)
          }

            //获取色号值十六进制转换RGB值
            this.recipeOrder.list.forEach(item => {
              let colorObj=colorRgb(item.colorRgb?"#"+item.colorRgb:"");
              item.colorRgb=colorObj.colorRgb;
              item.gcColorRgb=colorObj.gcColorRgb;
            });
            
            if (this.queryPageData.page == res.data.result.totalPage) {
                this.finished = true;
            }
            this.loading = false;
          }
        });
         this.$nextTick(() => {
          this.recipeOrder.list.forEach(item => {
          item.deviantColor = '偏红，白色'
        })
         })
        console.log("数据x",this.recipeOrder);
    },

    //重置搜索条件
    resetSearch(){
      //关键字
      this.searchVla = "";
      this.fieldValue = "";
      this.fieldValue1 = "";

      //清空配方分类选中
      this.formulaTypeArr.forEach(item => {
        item.color = "rgb(235,235,235)";
        item.fontColor = '#969799'
      });
     
      this.recipeAddData = { 
        // 年款
        recipeYear:"",
        // 地域
        uploadRegionCode: '',
        uploadRegionName: '',
        // 适用车龄 100001
        carAge: '',
        // 适用车龄
        carAgeDesc: '',
        // 汽车品牌代码
        carBrandCode: '',
        // 汽车品牌名称
        carBrandName: '',
        // 车型代码
        carModelCode: '',
        // 车型名称
        carModelName: '',
        // 车型ID
        gdModelId: '',
        // 颜色ID
        gdColorId: ''
      }
      this.queryPageData.data = {
        // 车龄
        carAge:'',
        // 车辆品牌
        carBrandCode:'',
        // 车辆OEM
        carOemCode	:'',
        // 颜色组别
        colorGroup: null,
        // 颜色效果
        colorSpecial: null,
        // GD色号ID
        gdColorId:'',
        // GD车型ID
        gdModelId:'',
        // 搜索关键字
        keys: [],
        // 油漆品牌代码
        paintBrandCode: this.queryPageData.data.paintBrandCode,
        // 
        recipeTypes: [],
        // 年款
        recipeYear: null,
        // 排序方式
        sort:'desc',
        // 上传地域代码
        uploadRegionCode:'',
        // 优先排序字段
        firstSort: '4'
      }
      // 重置后，搜索条件框显示
      const storeStates = storeState();
      storeStates.searchShowDiv = true;
    },

    // 筛选
    screenClick() {
      this.triangle = true;
      const storeStates = storeState() 
      if (storeStates.searchShowDiv) {
        storeStates.searchShowDiv = false;
      } else {
        storeStates.searchShowDiv = true;
      }
    },
    // 优先排序方法
    firstSortClick(item) {
      this.queryPageData.data.firstSort = item.value;
      this.firstText = item.text;
      this.searchDivClick();
    },
    // 订单的点击事件(订单详情)
    orderClick(item) {
      const storeStates = storeState()
      storeStates.recipeNo = item.recipeNo;
      storeStates.recipeQueryType = "2";
      storeStates.queryPageData = this.queryPageData.data;
      storeStates.searchVla = this.searchVla;
      storeStates.recipeAddData = this.recipeAddData;
      storeStates.fieldValue1 = this.fieldValue1;
      this.$router.push({
        path:'/app-h5-cn/page/orders',
        query: {
          ordId: '1',
        }
      }).catch(err => console.log("报错",err))
    },
    Fun() {
      this.loading = false;
    },
    // 软键盘搜索事件
    handleKeyUp(ev) {
      if (ev.keyCode == 13) {
        // 隐藏软键盘
        this.$refs.inputText.blur();
        //键盘回车的编码是13
        this.searchDivClick();
      }
    },
     // 清除指定过滤条件
    delClick(type){
      console.log(type);
      //汽车品牌
      if(type=='car_brand'){
        this.recipeAddData.oemCode="";
        this.recipeAddData.carBrandCode="";
        this.recipeAddData.carBrandName="";
        this.recipeAddData.carModelName="";
        this.recipeAddData.carModelCode="";
        this.recipeAddData.gdModelId="";
        this.fieldValue1 = '';
        this.cascaderValue1 = '';
        this.queryPageData.data.gdColorId = "";
        this.queryPageData.data.colorName = "";

        this.queryPageData.data.carOemCode = "";
        this.queryPageData.data.carBrandCode = "";
        this.queryPageData.data.gdModelId = "";

      }else if(type=='car_model'){
        //汽车车型
        this.recipeAddData.carModelName="";
        this.recipeAddData.carModelCode="";
        this.recipeAddData.gdModelId="";

        this.queryPageData.data.gdModelId = "";
      }else if(type=='color_code'){
        //色号
        this.fieldValue1 = '';
        this.cascaderValue1 = '';
        this.queryPageData.data.gdColorId = "";
        this.queryPageData.data.colorName = "";
      }else if(type=='model_year'){
        //年款
        this.recipeAddData.recipeYear='';
        this.queryPageData.data.recipeYear = "";
      }else if(type=='applicable_car_age'){
        //车龄
        this.recipeAddData.carAgeDesc = '';
        this.recipeAddData.carAge = '';
        this.vehicleValue = '';
        this.queryPageData.data.carAge = '';
      }else if(type=='upload_location'){
        //上传地域
        this.recipeAddData.uploadRegionName = '';
        this.recipeAddData.uploadRegionCode = '';
        this.queryPageData.data.uploadRegionCode = '';
      }else if(type=='recipe_type'){
        //配方分类
        this.queryPageData.data.recipeTypes = [];
        this.queryPageData.data.recipeTypesValue = '';
      }else if(type=='color_group'){
        //颜色组别
        this.queryPageData.data.colorGroup = '';
        this.queryPageData.data.colorGroupValue='';
      }else if(type=='color_effects'){
        //颜色特效
        this.queryPageData.data.colorSpecial = '';
        this.queryPageData.data.colorSpecialValue='';
      }
    },
    onLoad() {
      // const storeStates = storeState();
      // 如果是详情返回的,证据条件
      // if (!storeStates.searchShowDiv) {
      //   this.queryPageData.data = storeStates.queryPageData
      // }
      // 数据全部加载完成
        this.queryPageData.page += 1;
        // 进入首页，请求数据
        Api.queryPage(this.queryPageData).then((res) => {
          if (res.data.success) {
           this.loading = false;
          } else {
            return;
          }
          console.log(res);
          this.recipeOrder.currPage = res.data.result.currPage;
          this.recipeOrder.pageSize = res.data.result.pageSize;
          this.recipeOrder.totalCount = res.data.result.totalCount;
          this.recipeOrder.totalPage = res.data.result.totalPage;
          

          // 配方平均几颗星
          for (let index = 0; index < res.data.result.list.length; index++) {
            this.recipeOrder.list.push(res.data.result.list[index]);
            // 评分
            let imgUrlArrs = [];
            let imgUrls = { url: require("../assets/image/scoreTrue.png") }
            let avgScores = res.data.result.list[index].avgScore
            let lenghtOr = parseInt(avgScores) *1;
            for (let index = 0; index < lenghtOr; index++) {
              imgUrlArrs.push(imgUrls)
            }
            this.commentLevelImg.push(imgUrlArrs)
          }




          
          //获取色号值十六进制转换RGB值
          this.recipeOrder.list.forEach(item => {
            let colorObj=colorRgb(item.colorRgb?"#"+item.colorRgb:"");
            item.colorRgb=colorObj.colorRgb;
            item.gcColorRgb=colorObj.gcColorRgb;
          });
          if (this.queryPageData.page == res.data.result.totalPage) {
            this.finished = true;
          }
          this.loading = false;
        });
        
    },
  },
  mounted() {

  
},
  async created() {
  
    const storeStates = storeState();
    window.addEventListener("scroll",()=>{// 滚动事件
        let html =document.documentElement 
        if (html.scrollTop>=100) {//当滚动高度大于等于100返回顶部出现
            this.top=true
        }
    });
    // 赋值条件
    if (storeStates.searchState === '1') {
      // 年款
      this.recipeAddData.recipeYear = storeStates.recipeAddData.recipeYear;
      // 适用车龄
      this.recipeAddData.carAgeDesc = storeStates.recipeAddData.carAgeDesc;
      this.recipeAddData.carAge = storeStates.recipeAddData.carAge;
      // 上传地域
      this.recipeAddData.uploadRegionName = storeStates.recipeAddData.uploadRegionName;
      this.recipeAddData.uploadRegionCode = storeStates.recipeAddData.uploadRegionCode;
      // 汽车品牌
      this.recipeAddData.carBrandName = storeStates.recipeAddData.carBrandName;
      this.recipeAddData.carBrandCode = storeStates.recipeAddData.carBrandCode;
      // 车型
      this.recipeAddData.carModelName = storeStates.recipeAddData.carModelName;
      this.recipeAddData.carModelCode = storeStates.recipeAddData.carModelCode;
      // 车色号
      this.fieldValue1 = storeStates.fieldValue1;
      // 颜色组别
      this.queryPageData.data.colorGroup = storeStates.queryPageData.colorGroup;
      // 颜色效果
      this.queryPageData.data.colorSpecial = storeStates.queryPageData.colorSpecial;

      
      this.searchVla = storeStates.searchVla;
      if (this.$route.query.searchCode === '0') {
        this.resetSearch();
      }
    }
    await this.ApiMountend();

    // 搜索条件
    switch (this.queryPageData.data.firstSort) {
      case '1':
        this.firstText = '使用次数';
        break;
      case '2':
        this.firstText = '配方评分';
        break;
      case '3':
        this.firstText = '上传时间';
        break;
      case '4':
        this.firstText = '综合排序';
        break;
      default:
        break;
    }
    console.log('this.queryPageData', this.queryPageData);
  },
};
</script>

<style scoped lang="scss">
.div-box {
  // background-color: white;
  .nav-box {
    background-color: white;
    // position: fixed;
    // z-index: 12;
    .van-col-title {
        display: flex;
        justify-content: center;
        h3 {
            line-height: .7rem;
            font-size: 1rem;
        }
    }
    .van-col-icon {
        margin-top: .7rem;
        margin-left: 8px;
    }
  }
  .div-record {
    width: 90%;
    height: auto;
    padding: 10px 0px;
    // margin-top: 2.9rem;
    // border: white;
    background-color: white;
    position: fixed;
    margin:10px 5%;
    top:calc(40px + 38px  + constant(safe-area-inset-top));
    top:calc(40px + 38px  + env(safe-area-inset-top));
    box-shadow: 0px 2px 6px 0px rgba(125,125,125,1);
    z-index:1000;
    font-size:13px;
  }
  .div-nav {
    width: 100%;
    height: auto;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-top: calc(40px + constant(safe-area-inset-top));
    margin-top: calc(40px + env(safe-area-inset-top));
   position: fixed;
    top: 0px;
    z-index:999;
    // border: white;
    background-color: white;
    .sea-inpt-div {
        // margin-left: 2rem;
        margin-top: .5rem;
        .sea-inpt-siz {
            font-size: 1rem;
            margin-right: 10px;
            // font-weight: 100;
        }
    }
    /deep/ .van-field__left-icon .van-icon,
    .van-field__right-icon .van-icon {
      font-size: 1.2rem;
    }
    /deep/ .van-cell {
      border: rgb(243, 243, 249);
      width: 100%;
      background: rgb(243, 243, 249);
      border-radius: 20px;
    }
  }

  /deep/ .div-subejc .van-cell  .van-cell::after {
      border-bottom: none !important;
}

  .div-subejc  {
    width: 100%;
    background-color: white;
   // margin-top: 11vh;
   position: fixed;
    top: 0px;
    z-index: 999;
   margin-top: calc(40px + 50px + constant(safe-area-inset-top));
    margin-top: calc(40px + 50px + env(safe-area-inset-top));
    .subejc-mang-botn {
        margin-bottom: 1rem;
    }
    .div-subejc-box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        // background-color: red;
        .div-subejc-div {
            // width: 6.5rem;
            width: 25%;
            height: 1.8rem;
            margin-right: .8rem;
            background-color: rgb(235,235,235);
            border-radius: .8rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 10px;
            font-size: 13px;
        }
    }
    .div-subejc-box-recipe {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        // background-color: red;
        .div-subejc-div {
            // width: 6.5rem;
            width: 28%;
            height: 1.8rem;
            margin-right: .8rem;
            background-color: rgb(235,235,235);
            border-radius: .8rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 10px;
            font-size: 13px;
        }
    }
  }
  .sort-style {
    border-radius: 1px red solid;
    width: 100%;
    height: 30px;
    padding: 5px 0px;
    display: flex;
    justify-content: space-between;
    .icon-img {
      margin-top: 8px;
      height: 18px;
      // float: right;
    }
    .iconX {
      margin-top: 8px;
      // transform: rotate(180deg);
      // float: right;
    }
    .iconS {
      margin-top: 8px;
      // float: right;
      // transform: rotate(-180deg);
    }
    .iconDiv {
      float: right;
      width: 20px;
      height: 20px;
      // background-color: aqua;
    }
    .iconDivT {
      margin-right: 3px;
      margin-top: 7px;
      font-size: .9rem;
    }
  }
  .triangle-style {
    width: 100%;
    // height: 50px;
    padding: 8px 0;
    background-color: #fff;
    .triangle-or {
      width: 90%;
      // color: rgb(225,86,87);
      margin-left: 5%;
      padding: 8px 0;
      display: flex;
      justify-content: space-between;
    }
  }
  .search-dev {
    width: 100vw;
    clear:both;
   // margin-top: 20vh;

 
   margin-top: calc(40px + 45px + 0.8rem );
   padding-bottom:100px;
  // margin-top: calc(40px + 45px + 0.8rem + constant(safe-area-inset-top));
  //  margin-top: calc(40px + 45px + 0.8rem  + env(safe-area-inset-top));
    .search-dev-order {
      width: 90%;
      height: 100px;
      background-color: yellow;
    }
  }
}
.img-styles {
  // margin-top: 4px;
  width: 15px;
  position: relative;
  top: 3px;
}
.More-div {
  /deep/ .van-cell__title, .van-cell__value {
    position: relative;
    left:44%;
  }
  /deep/ .van-cell__left-icon {
    position: relative;
    left: 24%;
  } 
}
/deep/ .van-picker__title {
    font-size: 1.2rem;
    font-weight: 400;
}
.searchBtn {
  width: 100vw;
  height: 4.6rem;
  position: fixed;
  background-color: white;
  bottom: 0px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .searchBtn-d1 {
    // background-color: red;
    width: 40%;
    /deep/ .van-button--info {
      background-color: (0,133,190);
      border: solid 1px white;
      width: 100%;
    }
  }
  .searchBtn-d2 {
    width: 40%;
    // border: solid 1px red;
    /deep/ .van-button--info {
      background-color: rgb(239,240,244);
      border: solid 1px rgb(0,139,250);
      color: rgb(0,139,250);
      width: 100%;
    }
  }
}
.span-colorOne {
  color: black;
  font-size: 85rem;
}
.order-box {
  width: 100%;
  display: flex;
  // background-color: red;
  justify-content: center;
  margin-top: .8rem;
  .div-box-txt {
    background-color: white;
    border-radius: 5px;
    width: 90%;
    // height: 12rem;
    padding-bottom: 1rem;
    overflow:hidden;
    .d1 {
      width: 100%;
      height: 5.6rem;
      display: flex;
      // border: solid 1px red;
      .d1-title1 {
        width: 1.9rem;
        height: 100%;
        // background-color: rgb(255, 255, 255);/* 针对不支持渐变的浏览器 */
        // background-image: linear-gradient(rgb(180,-70,-70),rgb(250,0,0),rgb(250,0,0), rgb(180,-70,-70));
        // background-image: linear-gradient(rgba(180,0,0,0.1),rgb(255,255,255));
      }
      .d1-title2 {
        width: calc(100% - 1.9rem);
        height:calc(100% - 2px);
        display: flex;
        // border-bottom: solid .01rem rgb(138, 138, 138);
        // background-color: aquamarine;
        .d1-title1-txt1 {
          width: 100%;
          height: calc(100% - .9rem);
          margin-top: .8rem;
          // background-color: rgb(255, 255, 255);
          
          .img-log {
            height: 2rem;
            margin: .2333rem .5333rem;
            position: absolute;
            right: 1.5rem;
          }
          .txt-span {
            font-size: 1rem;
            font-weight: 600;
            position: relative;
            left: 10px;
            margin-right: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .div-end {
            width: 100%;
            height:calc(100% - 1.3rem);
            display: flex;
            align-items: center;
            position: relative;
            top: -3px;
            // background-color: rgb(9, 255, 1);
            .end-d1 {
              width: 75%;
              display: flex;
              align-items: center;
            }
            .end-preview {
              width: 25%;
              height: 100%;
              margin-top: .6rem;
              position: relative;
              top: .7rem;
              .icon-imgs-style {
                display: flex;
                align-items: center;
              }
              /deep/ .van-icon {
                color: rgb(0,145,220);
              }
            }
            .icon-box {
              padding: 10px 7px;
              font-size: 0.7rem;
              border-radius: 10px;
              margin-right: .2rem;
              margin-left: .2rem;
            }
            .icon-circle {
              all: initial;
              padding: 1px 5px;
              height: 1.1rem;
              border-radius: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: rgb(254,240,205);
              color:  #FF6600;
              font-size: .3733rem;
              // padding: 1px 10px;
              padding-left: .2667rem;
              padding-right: .2667rem;
              padding-bottom: .17rem;
              margin-right: .75rem;
              margin-left: .6rem;
            }
              .icon-circle-class {
                font-size: 0.7rem;
                padding-top: 1px;
              }
          }
          .icon-circleTwo {
              all: initial;
              padding: 1px 5px;
              height: 1.1rem;
              border-radius: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: rgb(199,231,242);
              color:  rgb(0,132,184);
              font-size: .3733rem;
              padding-left: .2667rem;
              padding-right: .2667rem;
              padding-bottom: .17rem;
              // padding-top: .1;
              margin-right: .75rem;
          }
          .icon-circleThree {
              all: initial;
              padding: 1px 5px;
              height: 1.1rem;
              border-radius: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: rgb(226,233,206);
              color:  rgb(109,148,25);
              font-size: .3733rem;
              padding-left: .2667rem;
              padding-right: .2667rem;
              padding-bottom: .17rem;
              // padding-top: .1;
              margin-right: .75rem;
              // margin-top: .7rem;
          }
        }
      }
    }
    .d2 {
      height: 5.5rem;
      width: 100%;
      .span-h3-box {
        width: 100%;
        overflow: hidden;//溢出隐藏
          text-overflow: ellipsis;//属性值表示当对象内文本溢出时显示省略标记，省略标记插入的位置是最后一个字符。
          white-space: nowrap;//只保留一个空白，文本不会换行，会在在同一行上继续，直到遇到br标签为止。
        // display: flex;
        // align-items: center;
        // flex-wrap:wrap;
        font-size: .85rem;
        font-weight: 600;
        color: rgb(144,144,144);
        .span-h3 {
          margin-left: 5px;
          font-size: .85rem;
          font-weight: 600;
          color: rgb(144,144,144);
        }
      }
      
      span {
        font-size: .7rem;
      }
      .van-rows {
        margin-top: .6rem;
        .span-min {
          font-weight: 400;
          color: #909090;
        }
      }
    }
  }
}
/deep/ .van-cell {
  padding: 6px 15px;
  font-size: 13px;
}
.van-field__controls {
  /deep/ .van-field__control {
    line-height: 1.9rem;
  }
  /deep/ .van-field__left-icon .van-icon, .van-field__right-icon .van-icon {
        line-height: 1.87rem;
  }
}
.col-div {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    
    .div-cell {
        width: 148px;
        height: 25px;
        margin-top: 8px;
        border-radius: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: solid 1px rgb(235,235,235);
        background-color: rgb(235,235,235);
    }
}
.BtnStyle {
  width: 100%;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0082BB;
}
#triangle-right {
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-left: 10px solid rgb(0,145,220);
    border-bottom: 5px solid transparent;
}

.popup-style {
  .cascader-input-style {
      position: absolute;
      width: 100%;
      height: 50px;
      margin-top: 40px;
      padding: 20px 0px;
  }
  /deep/ .van-tabs--line .van-tabs__wrap {
    margin-top: 39px;
  }
}

.stepper-div-btn {
    box-sizing: border-box;
    width: 90%;
    height: 2rem;
    margin: -10px 5%;
    padding: 2px 7px;
    color: #323233;
    font-size: 14px;
    line-height: normal;
    // text-align: center;
    // vertical-align: middle;
    background-color: rgb(243,242,249);
    border: 0;
    border-radius: 15px;
    -webkit-appearance: none;
}
// 弹框搜索
.stepper-div-btns {
    box-sizing: border-box;
    width: 90%;
    height: 2rem;
    margin: -10px 5%;
    padding: 2px 7px;
    color: #323233;
    font-size: 14px;
    line-height: normal;
    // text-align: center;
    // vertical-align: middle;
    background-color: rgb(243,242,249);
    border: 0;
    border-radius: 15px;
    -webkit-appearance: none;
}
/deep/ .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
  border: 1px solid white;
}
// /deep/ .van-cell__value--alone {
//         position: relative;left: 44%;
//   }
// 导航头
/deep/ .van-nav-bar__title {
  color: black !important;
  font-size: 1rem;
  font-weight: 600;
}
/deep/ .van-nav-bar__content {
    height: 40px;
  }

/deep/ .van-nav-bar .van-icon {
  color: black;
}
/deep/ .van-field__label {
  color: #323233;
}
// 箭头旋转
.div-deg {
  /deep/ .van-cell__right-icon {
    transform: rotate(90deg);
  }
}
.fontSize13 {
  font-size: 13px;
}
.up-style {
  display:flex;
  font-size: 0.9rem;
}
/deep/ .van-field__control {
  font-size: 14px;
}
.collapse-icon{
  vertical-align:-2px;
}
</style>
